import styled from 'styled-components';
import { animated } from 'react-spring';
import { deepSkyBlue, neonRed } from 'styles/colors';
import { zindexs } from 'styles/variables';

export const Container = styled.div`
  position: fixed;
  z-index: ${zindexs.toaster};
  width: 0 auto;
  top: ${props => (props.top ? '110px' : 'unset')};
  bottom: ${props => (props.top ? 'unset' : '30px')};
  margin: 0 auto;
  left: 30px;
  right: 30px;
  display: flex;
  flex-direction: ${props => (props.top ? 'column-reverse' : 'column')};
  pointer-events: none;
  align-items: ${props => (props.position === 'center' ? 'center' : `flex-${props.position || 'end'}`)};
`;

export const Message = styled(animated.div)`
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
  width: 40ch;
  margin-top: ${props => (props.top ? '0' : '10px')};
  margin-bottom: ${props => (props.top ? '10px' : '0')};
`;

export const Content = styled.div`
  color: white;
  background: ${props => props.error ? neonRed : '#445159'};
  opacity: 0.9;
  padding: 15px 20px 15px 20px;
  font-family: CircularStd, sans-serif;
  font-size: 14px;
  font-weight: 400;
  display: grid;
  grid-template-columns: ${props => (props.canClose === false ? '1fr' : '1fr auto')};
  grid-gap: 15px;
  overflow: hidden;
  height: auto;

  p {
    margin: 0;
  }
`;

export const Button = styled.button`
  cursor: pointer;
  pointer-events: all;
  outline: 0;
  border: none;
  background: transparent;
  display: flex;
  align-self: flex-center;
  overflow: hidden;
  margin: 0;
  padding: 0;
  color: rgba(255, 255, 255, 0.5);
`;

export const Life = styled(animated.div)`
  position: absolute;
  bottom: ${props => (props.top ? '10px' : '0')};
  left: 0px;
  width: auto;
  height: 3px;
  background-image: linear-gradient(130deg, #00b4e6, ${deepSkyBlue});
`;
